import * as React from "react";

export function useInViewport(className = "is-inViewport") {
  const ref = React.useRef<any | null>(null);

  React.useEffect(() => {
    let Observer: IntersectionObserver;
    const inViewport = (entries: IntersectionObserverEntry[]) => {
      const entry =
        ref.current && entries.find((x) => x.target === ref.current);
      if (ref.current && entry) {
        ref.current.classList.toggle(className, entry.isIntersecting);
      }
    };

    if (ref.current) {
      const Observer = new IntersectionObserver(inViewport);
      Observer.observe(ref.current);
    }
    return () => {
      if (Observer) {
        Observer.disconnect();
      }
    };
  }, [className]);

  return ref;
}
